import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { Alert, AlertTitle, Flex, Text } from '@shared/components';
import { useMemo } from 'react';

import { sortLosByStructure } from '../../utils';

import { publishQConfigErrorsByPage, QConfigPublishValidationErrorCode } from './constants';
import PublishRequiredList from './publish-required-list';
import { getDisabledLOSList } from './utils';

export default function QConfigPublishErrorsAlert() {
  const {
    publishQConfig: { errors },
    qConfigData: { structures },
  } = useQConfig();

  const errorCodes = errors?.map((error) => error.code) ?? [];

  const hasErrorWithMessage = Object.values(publishQConfigErrorsByPage).some((errorMessages) =>
    errorMessages.some((error) => errorCodes.includes(error)),
  );

  const disabledLOSList = useMemo(() => {
    const losError = getDisabledLOSList(errors);

    if (!losError?.length) {
      return [];
    }
    return sortLosByStructure(losError, structures);
  }, [errors, structures]);

  if (!errors?.length || !hasErrorWithMessage) {
    return null;
  }

  return (
    <Alert
      severity='error'
      sx={{
        alignItems: 'flex-start',
        '& .MuiAlert-message': {
          overflow: 'unset',
        },
      }}
    >
      <AlertTitle
        variant='body1Semibold'
        sx={(theme) => ({
          m: theme.spacing(0),
          //TODO: Remove font weight override when fix AlertTitle font weight override issue
          fontWeight: 600,
        })}
      >
        ไม่สามารถ Publish QConfig ได้
      </AlertTitle>
      <Flex
        sx={{
          flexDirection: 'column',
        }}
      >
        {!errorCodes.includes(QConfigPublishValidationErrorCode.QUESTIONS_NOT_ENOUGH) ? (
          <PublishRequiredList
            errors={errorCodes}
            values={{
              DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND: {
                disabledLOSList,
              },
            }}
          />
        ) : (
          <Text variant='body2'>เนื่องจากข้อสอบในคลังมีไม่เพียงพอ</Text>
        )}
      </Flex>
    </Alert>
  );
}
